import {FeedbackFormStructureUpdateRequest} from '../../../../shared/types/generated/feedbackFormStructureUpdateRequest';
import {FeedbackCompletionMode} from '../../../../shared/types/generated/feedbackCompletionMode';
import {FeedbackCompletionResultDisplay} from '../../../../shared/types/generated/feedbackCompletionResultDisplay';
import {FeedbackPassingThresholdType} from '../../../../shared/types/generated/feedbackPassingThresholdType';
import {FeedbackFormStructureResource} from '../../../../shared/types/generated/feedbackFormStructureResource';
import {FeedbackQuestionDateConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionDateConfigurationResource';
import {FeedbackQuestionDateConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionDateConfigurationInput';
import {FeedbackQuestionDateTimeConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionDateTimeConfigurationResource';
import {FeedbackQuestionDateTimeConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionDateTimeConfigurationInput';
import {FeedbackQuestionDropdownConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionDropdownConfigurationResource';
import {FeedbackQuestionDropdownConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionDropdownConfigurationInput';
import {FeedbackQuestionDropdownOptionResource} from '../../../../shared/types/generated/feedbackQuestionDropdownOptionResource';
import {FeedbackQuestionFilesConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionFilesConfigurationResource';
import {FeedbackQuestionFilesConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionFilesConfigurationInput';
import {FeedbackLogicRuleAction} from '../../../../shared/types/generated/feedbackLogicRuleAction';
import {FeedbackLogicRuleOperator} from '../../../../shared/types/generated/feedbackLogicRuleOperator';
import {FeedbackQuestionMultiSelectionConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionMultiSelectionConfigurationResource';
import {FeedbackQuestionMultiSelectionConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionMultiSelectionConfigurationInput';
import {FeedbackQuestionOrderingConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionOrderingConfigurationResource';
import {FeedbackQuestionOrderingConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionOrderingConfigurationInput';
import {FeedbackQuestionOrderingOptionResource} from '../../../../shared/types/generated/feedbackQuestionOrderingOptionResource';
import {FeedbackQuestionRatingConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionRatingConfigurationResource';
import {FeedbackQuestionRatingConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionRatingConfigurationInput';
import {FeedbackQuestionResource} from '../../../../shared/types/generated/feedbackQuestionResource';
import {FeedbackQuestionSelectionOptionResource} from '../../../../shared/types/generated/feedbackQuestionSelectionOptionResource';
import {FeedbackQuestionSelectionOptionInput} from '../../../../shared/types/generated/feedbackQuestionSelectionOptionInput';
import {FeedbackQuestionSingleSelectionConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionSingleSelectionConfigurationResource';
import {FeedbackQuestionSingleSelectionConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionSingleSelectionConfigurationInput';
import {FeedbackQuestionSliderConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionSliderConfigurationResource';
import {FeedbackQuestionSliderConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionSliderConfigurationInput';
import {FeedbackQuestionTextInputConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionTextInputConfigurationResource';
import {FeedbackQuestionTextInputConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionTextInputConfigurationInput';
import {FeedbackQuestionTimeConfigurationResource} from '../../../../shared/types/generated/feedbackQuestionTimeConfigurationResource';
import {FeedbackQuestionTimeConfigurationInput} from '../../../../shared/types/generated/feedbackQuestionTimeConfigurationInput';
import {FeedbackQuestionType} from '../../../../shared/types/generated/feedbackQuestionType';
import {FeedbackQuestionDropdownOptionInput} from '../../../../shared/types/generated/feedbackQuestionDropdownOptionInput';
import {FeedbackQuestionOrderingOptionInput} from '../../../../shared/types/generated/feedbackQuestionOrderingOptionInput';
import {FeedbackStructureQuestionFormBase} from '../../../../shared/types/feedback-types/feedbackStructureQuestionFormBase.interface';
import {FeedbackStructureDateQuestion} from '../../../../shared/types/feedback-types/feedbackStructureDateQuestion.type';
import {FeedbackStructureDateTimeQuestion} from '../../../../shared/types/feedback-types/feedbackStructureDateTimeQuestion.type';
import {FeedbackStructureDropdownQuestion} from '../../../../shared/types/feedback-types/feedbackStructureDropdownQuestion.type';
import {FeedbackStructureFilesQuestion} from '../../../../shared/types/feedback-types/feedbackStructureFilesQuestion.type';
import {FeedbackStructureMultiSelectionQuestion} from '../../../../shared/types/feedback-types/feedbackStructureMultiSelectionQuestion.type';
import {FeedbackStructureOrderingQuestion} from '../../../../shared/types/feedback-types/feedbackStructureOrderingQuestion.type';
import {FeedbackStructureQuestionFormQuestion} from '../../../../shared/types/feedback-types/feedbackStructureQuestionFormQuestion.type';
import {FeedbackStructureQuestionLogicRule} from '../../../../shared/types/feedback-types/feedbackStructureQuestionLogicRule.type';
import {FeedbackStructureQuestionOption} from '../../../../shared/types/feedback-types/feedbackStructureQuestionOption.interface';
import {FeedbackStructureRatingQuestion} from '../../../../shared/types/feedback-types/feedbackStructureRatingQuestion.type';
import {FeedbackStructureSaveConfigurationWithOptions} from '../../../../shared/types/feedback-types/feedbackStructureSaveConfigurationWithOptions.type';
import {FeedbackStructureSaveQuestion} from '../../../../shared/types/feedback-types/feedbackStructureSaveQuestion.type';
import {FeedbackStructureSingleSelectionQuestion} from '../../../../shared/types/feedback-types/feedbackStructureSingleSelectionQuestion.type';
import {FeedbackStructureSliderQuestion} from '../../../../shared/types/feedback-types/feedbackStructureSliderQuestion.type';
import {FeedbackStructureTextInputQuestion} from '../../../../shared/types/feedback-types/feedbackStructureTextInputQuestion.type';
import {FeedbackStructureTimeQuestion} from '../../../../shared/types/feedback-types/feedbackStructureTimeQuestion.type';

export type {FeedbackStructureQuestionFormBase} from '../../../../shared/types/feedback-types/feedbackStructureQuestionFormBase.interface';
export type {FeedbackStructureDateQuestion} from '../../../../shared/types/feedback-types/feedbackStructureDateQuestion.type';
export type {FeedbackStructureDateTimeQuestion} from '../../../../shared/types/feedback-types/feedbackStructureDateTimeQuestion.type';
export type {FeedbackStructureDropdownQuestion} from '../../../../shared/types/feedback-types/feedbackStructureDropdownQuestion.type';
export type {FeedbackStructureFilesQuestion} from '../../../../shared/types/feedback-types/feedbackStructureFilesQuestion.type';
export type {FeedbackStructureMultiSelectionQuestion} from '../../../../shared/types/feedback-types/feedbackStructureMultiSelectionQuestion.type';
export type {FeedbackStructureOptionQuestion} from '../../../../shared/types/feedback-types/feedbackStructureOptionQuestion.type';
export type {FeedbackStructureOrderingQuestion} from '../../../../shared/types/feedback-types/feedbackStructureOrderingQuestion.type';
export type {FeedbackStructureQuestionFormQuestion} from '../../../../shared/types/feedback-types/feedbackStructureQuestionFormQuestion.type';
export type {FeedbackStructureQuestionLogicRule} from '../../../../shared/types/feedback-types/feedbackStructureQuestionLogicRule.type';
export type {FeedbackStructureQuestionOption} from '../../../../shared/types/feedback-types/feedbackStructureQuestionOption.interface';
export type {FeedbackStructureRatingQuestion} from '../../../../shared/types/feedback-types/feedbackStructureRatingQuestion.type';
export type {FeedbackStructureSingleSelectionQuestion} from '../../../../shared/types/feedback-types/feedbackStructureSingleSelectionQuestion.type';
export type {FeedbackStructureSliderQuestion} from '../../../../shared/types/feedback-types/feedbackStructureSliderQuestion.type';
export type {FeedbackStructureTextInputQuestion} from '../../../../shared/types/feedback-types/feedbackStructureTextInputQuestion.type';
export type {FeedbackStructureTimeQuestion} from '../../../../shared/types/feedback-types/feedbackStructureTimeQuestion.type';

let nextLocalId = 0;

const FEEDBACK_LOGIC_RULE_OPERATORS_BY_TYPE: Record<FeedbackQuestionType, FeedbackLogicRuleOperator[]> = {
	[FeedbackQuestionType.SINGLE_SELECTION]: [
		FeedbackLogicRuleOperator.SELECTED,
		FeedbackLogicRuleOperator.NOT_SELECTED,
	],
	[FeedbackQuestionType.MULTI_SELECTION]: [
		FeedbackLogicRuleOperator.SELECTED,
		FeedbackLogicRuleOperator.NOT_SELECTED,
		FeedbackLogicRuleOperator.IS_EMPTY,
		FeedbackLogicRuleOperator.IS_NOT_EMPTY,
	],
	[FeedbackQuestionType.DROPDOWN]: [
		FeedbackLogicRuleOperator.EQUAL_TO,
		FeedbackLogicRuleOperator.NOT_EQUAL_TO,
	],
	[FeedbackQuestionType.ORDERING]: [],
	[FeedbackQuestionType.SLIDER]: [
		FeedbackLogicRuleOperator.LESS_THAN,
		FeedbackLogicRuleOperator.GREATER_THAN,
		FeedbackLogicRuleOperator.EQUAL_TO,
		FeedbackLogicRuleOperator.NOT_EQUAL_TO,
	],
	[FeedbackQuestionType.RATING]: [
		FeedbackLogicRuleOperator.LESS_THAN,
		FeedbackLogicRuleOperator.GREATER_THAN,
		FeedbackLogicRuleOperator.EQUAL_TO,
		FeedbackLogicRuleOperator.NOT_EQUAL_TO,
	],
	[FeedbackQuestionType.TEXT_INPUT]: [
		FeedbackLogicRuleOperator.IS_EMPTY,
		FeedbackLogicRuleOperator.IS_NOT_EMPTY,
		FeedbackLogicRuleOperator.EQUAL_TO,
		FeedbackLogicRuleOperator.NOT_EQUAL_TO,
		FeedbackLogicRuleOperator.CONTAINS,
		FeedbackLogicRuleOperator.NOT_CONTAINS,
	],
	[FeedbackQuestionType.DATE_TIME]: [
		FeedbackLogicRuleOperator.LESS_THAN,
		FeedbackLogicRuleOperator.GREATER_THAN,
		FeedbackLogicRuleOperator.EQUAL_TO,
		FeedbackLogicRuleOperator.NOT_EQUAL_TO,
		FeedbackLogicRuleOperator.IS_EMPTY,
		FeedbackLogicRuleOperator.IS_NOT_EMPTY,
	],
	[FeedbackQuestionType.TIME]: [
		FeedbackLogicRuleOperator.LESS_THAN,
		FeedbackLogicRuleOperator.GREATER_THAN,
		FeedbackLogicRuleOperator.EQUAL_TO,
		FeedbackLogicRuleOperator.NOT_EQUAL_TO,
		FeedbackLogicRuleOperator.IS_EMPTY,
		FeedbackLogicRuleOperator.IS_NOT_EMPTY,
	],
	[FeedbackQuestionType.DATE]: [
		FeedbackLogicRuleOperator.LESS_THAN,
		FeedbackLogicRuleOperator.GREATER_THAN,
		FeedbackLogicRuleOperator.EQUAL_TO,
		FeedbackLogicRuleOperator.NOT_EQUAL_TO,
		FeedbackLogicRuleOperator.IS_EMPTY,
		FeedbackLogicRuleOperator.IS_NOT_EMPTY,
	],
	[FeedbackQuestionType.FILES]: [
		FeedbackLogicRuleOperator.IS_EMPTY,
		FeedbackLogicRuleOperator.IS_NOT_EMPTY,
	],
};

export function getAllowedFeedbackLogicRuleOperators(type: FeedbackQuestionType): FeedbackLogicRuleOperator[] {
	return FEEDBACK_LOGIC_RULE_OPERATORS_BY_TYPE[type];
}

export function isFeedbackLogicRuleOperatorAllowed(
	type: FeedbackQuestionType,
	operator: FeedbackLogicRuleOperator
): boolean {
	return getAllowedFeedbackLogicRuleOperators(type).includes(operator);
}

export function parseFeedbackStructureQuestionForSave(
	question: FeedbackStructureQuestionFormQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	switch (question.type) {
		case FeedbackQuestionType.SINGLE_SELECTION:
			return parseSingleSelectionQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.MULTI_SELECTION:
			return parseMultiSelectionQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.DROPDOWN:
			return parseDropdownQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.ORDERING:
			return parseOrderingQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.SLIDER:
			return parseSliderQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.RATING:
			return parseRatingQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.TEXT_INPUT:
			return parseTextInputQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.DATE_TIME:
			return parseDateTimeQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.TIME:
			return parseTimeQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.DATE:
			return parseDateQuestionForSave(question, allQuestions);
		case FeedbackQuestionType.FILES:
			return parseFilesQuestionForSave(question, allQuestions);
	}
}

export function parseFeedbackStructureResourceForSave(
	structure: FeedbackFormStructureResource,
	omitQuestionIds: boolean = false
): FeedbackFormStructureUpdateRequest {
	const formQuestions = normalizeFeedbackStructureQuestions(
		structure.questions.map((question) => parseFeedbackQuestionResourceForForm(question))
	);

	return {
		completion: parseFeedbackCompletionForSave(structure.completion),
		questions: formQuestions.map((question) => {
			const saveQuestion = parseFeedbackStructureQuestionForSave(question, formQuestions);

			if (!omitQuestionIds) {
				return saveQuestion;
			}

			return removePersistedIdsFromSaveQuestion(saveQuestion);
		}),
	};
}

export function parseFeedbackCompletionForSave(
	completion: FeedbackFormStructureResource['completion'] | null | undefined
): NonNullable<FeedbackFormStructureUpdateRequest['completion']> {
	if (!completion || completion.mode === FeedbackCompletionMode.DISABLED) {
		return {
			mode: FeedbackCompletionMode.DISABLED,
			passing_threshold: null,
			result_display: null,
			text: null,
			failed_text: null,
		};
	}

	return {
		mode: completion.mode,
		passing_threshold: completion.mode === FeedbackCompletionMode.MESSAGE
			? null
			: completion.passing_threshold ?? {
				type: FeedbackPassingThresholdType.PERCENTAGE,
				value: 0,
			},
		result_display: completion.mode === FeedbackCompletionMode.MESSAGE
			? null
			: completion.result_display ?? FeedbackCompletionResultDisplay.PERCENTAGE,
		text: completion.text || null,
		failed_text: completion.mode === FeedbackCompletionMode.MESSAGE ? null : completion.failed_text || null,
	};
}

function removePersistedIdsFromSaveQuestion(question: FeedbackStructureSaveQuestion): FeedbackStructureSaveQuestion {
	const questionWithoutId = {...question};
	delete questionWithoutId.id;

	const configurationWithOptions = questionWithoutId.configuration as FeedbackStructureSaveConfigurationWithOptions;
	if (!Array.isArray(configurationWithOptions.options)) {
		return questionWithoutId;
	}

	return {
		...questionWithoutId,
		configuration: {
			...questionWithoutId.configuration,
			options: configurationWithOptions.options.map((option) => {
				const optionWithoutId = {...option};
				delete optionWithoutId.id;
				return optionWithoutId;
			}),
		} as FeedbackStructureSaveQuestion['configuration'],
	};
}

export function parseFeedbackQuestionResourceForForm(
	question: FeedbackQuestionResource
): FeedbackStructureQuestionFormQuestion {
	switch (question.type) {
		case FeedbackQuestionType.SINGLE_SELECTION:
			return createFormQuestion(
				question,
				FeedbackQuestionType.SINGLE_SELECTION,
				parseSingleSelectionConfiguration(question.configuration as FeedbackQuestionSingleSelectionConfigurationResource)
			);
		case FeedbackQuestionType.MULTI_SELECTION:
			return createFormQuestion(
				question,
				FeedbackQuestionType.MULTI_SELECTION,
				parseMultiSelectionConfiguration(question.configuration as FeedbackQuestionMultiSelectionConfigurationResource)
			);
		case FeedbackQuestionType.DROPDOWN:
			return createFormQuestion(
				question,
				FeedbackQuestionType.DROPDOWN,
				parseDropdownConfiguration(question.configuration as FeedbackQuestionDropdownConfigurationResource)
			);
		case FeedbackQuestionType.ORDERING:
			return createFormQuestion(
				question,
				FeedbackQuestionType.ORDERING,
				parseOrderingConfiguration(question.configuration as FeedbackQuestionOrderingConfigurationResource)
			);
		case FeedbackQuestionType.SLIDER:
			return createFormQuestion(question, FeedbackQuestionType.SLIDER, parseSliderConfiguration(
				question.configuration as FeedbackQuestionSliderConfigurationResource
			));
		case FeedbackQuestionType.RATING:
			return createFormQuestion(question, FeedbackQuestionType.RATING, parseRatingConfiguration(
				question.configuration as FeedbackQuestionRatingConfigurationResource
			));
		case FeedbackQuestionType.TEXT_INPUT:
			return createFormQuestion(question, FeedbackQuestionType.TEXT_INPUT, parseTextInputConfiguration(
				question.configuration as FeedbackQuestionTextInputConfigurationResource
			));
		case FeedbackQuestionType.DATE_TIME:
			return createFormQuestion(question, FeedbackQuestionType.DATE_TIME, parseDateTimeConfiguration(
				question.configuration as FeedbackQuestionDateTimeConfigurationResource
			));
		case FeedbackQuestionType.TIME:
			return createFormQuestion(question, FeedbackQuestionType.TIME, parseTimeConfiguration(
				question.configuration as FeedbackQuestionTimeConfigurationResource
			));
		case FeedbackQuestionType.DATE:
			return createFormQuestion(question, FeedbackQuestionType.DATE, parseDateConfiguration(
				question.configuration as FeedbackQuestionDateConfigurationResource
			));
		case FeedbackQuestionType.FILES:
			return createFormQuestion(question, FeedbackQuestionType.FILES, parseFilesConfiguration(
				question.configuration as FeedbackQuestionFilesConfigurationResource
			));
	}
}

export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.SINGLE_SELECTION,
	position: number,
	title: string | null
): FeedbackStructureSingleSelectionQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.MULTI_SELECTION,
	position: number,
	title: string | null
): FeedbackStructureMultiSelectionQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.DROPDOWN,
	position: number,
	title: string | null
): FeedbackStructureDropdownQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.ORDERING,
	position: number,
	title: string | null
): FeedbackStructureOrderingQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.SLIDER,
	position: number,
	title: string | null
): FeedbackStructureSliderQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.RATING,
	position: number,
	title: string | null
): FeedbackStructureRatingQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.TEXT_INPUT,
	position: number,
	title: string | null
): FeedbackStructureTextInputQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.DATE_TIME,
	position: number,
	title: string | null
): FeedbackStructureDateTimeQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.TIME,
	position: number,
	title: string | null
): FeedbackStructureTimeQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.DATE,
	position: number,
	title: string | null
): FeedbackStructureDateQuestion;
export function createDefaultQuestion(
	type: typeof FeedbackQuestionType.FILES,
	position: number,
	title: string | null
): FeedbackStructureFilesQuestion;
export function createDefaultQuestion(
	type: FeedbackQuestionType,
	position: number,
	title: string | null
): FeedbackStructureQuestionFormQuestion;
export function createDefaultQuestion(
	type: FeedbackQuestionType,
	position: number,
	title: string | null
): FeedbackStructureQuestionFormQuestion {
	const base = {
		client_id: createLocalId('question'),
		position,
		title,
		description: null,
		required: false,
		points: 0,
		time_limit_seconds: null,
		auto_advance_on_timeout: false,
		file_storage_uuids: [],
		files: [],
		logic_rules: [],
	};

	switch (type) {
		case FeedbackQuestionType.SINGLE_SELECTION:
			return {...base, type, configuration: {points: 0, options: []}, options: createDefaultOptions(type)};
		case FeedbackQuestionType.MULTI_SELECTION:
			return {...base, type, configuration: {points: 0, options: []}, options: createDefaultOptions(type)};
		case FeedbackQuestionType.DROPDOWN:
			return {...base, type, configuration: {points: 0, options: [], ...createDefaultCommentConfiguration()}, options: createDefaultOptions(type)};
		case FeedbackQuestionType.ORDERING:
			return {...base, type, configuration: {points: 0, options: []}, options: createDefaultOptions(type)};
		case FeedbackQuestionType.SLIDER:
			return {
				...base,
				type,
				configuration: {
					correct_answer: null,
					points: 0,
					...createDefaultCommentConfiguration(),
					min_value: 0,
					max_value: 10,
					step_size: 1,
					use_value_as_points: false,
					large_step_marker_interval: 1,
					small_step_marker_interval: null,
					start_value: 0,
					show_small_step_markers: false,
					show_tooltip_on_handle: false,
					unit: null,
					unit_position: null,
				},
				options: [],
			};
		case FeedbackQuestionType.RATING:
			return {
				...base,
				type,
				configuration: {
					correct_answer: null,
					points: 0,
					...createDefaultCommentConfiguration(),
					allow_half_stars: false,
					use_rating_as_points: false,
				},
				options: [],
			};
		case FeedbackQuestionType.TEXT_INPUT:
			return {...base, type, configuration: {correct_answer: null, points: 0, ...createDefaultCommentConfiguration()}, options: []};
		case FeedbackQuestionType.DATE_TIME:
			return {...base, type, configuration: {correct_answer: null, points: 0, ...createDefaultCommentConfiguration()}, options: []};
		case FeedbackQuestionType.TIME:
			return {...base, type, configuration: {correct_answer: null, points: 0, ...createDefaultCommentConfiguration()}, options: []};
		case FeedbackQuestionType.DATE:
			return {...base, type, configuration: {correct_answer: null, points: 0, ...createDefaultCommentConfiguration()}, options: []};
		case FeedbackQuestionType.FILES:
			return {...base, type, configuration: createFilesConfiguration(), options: []};
	}
}

export function createDefaultOption(type: FeedbackQuestionType, position: number): FeedbackStructureQuestionOption {
	return {
		client_id: createLocalId('option'),
		position,
		label: null,
		correct_answer: false,
		commentable: false,
		comment_prompt: null,
		correct_position: type === FeedbackQuestionType.ORDERING ? position : null,
		file_storage_uuid: null,
		file: null,
	};
}

export function isSelectionQuestionType(type: FeedbackQuestionType): boolean {
	return (
		type === FeedbackQuestionType.SINGLE_SELECTION ||
		type === FeedbackQuestionType.MULTI_SELECTION ||
		type === FeedbackQuestionType.DROPDOWN ||
		type === FeedbackQuestionType.ORDERING
	); 
}

export function isOptionContentComplete(option: Pick<FeedbackStructureQuestionOption, 'label' | 'file_storage_uuid' | 'file'>): boolean {
	return Boolean(option.label?.trim()) || Boolean(option.file_storage_uuid || option.file?.uuid);
}

function createDefaultOptions(type: FeedbackQuestionType): FeedbackStructureQuestionOption[] {
	return Array.from(
		{length: getInitialOptionCount(type)},
		(_, position) => createDefaultOption(type, position)
	);
}

function getInitialOptionCount(type: FeedbackQuestionType): number {
	switch (type) {
		case FeedbackQuestionType.SINGLE_SELECTION:
		case FeedbackQuestionType.MULTI_SELECTION:
		case FeedbackQuestionType.DROPDOWN:
		case FeedbackQuestionType.ORDERING:
			return 2;
		default:
			return 0;
	}
}

function ensureMinimumOptions(question: FeedbackStructureQuestionFormQuestion): FeedbackStructureQuestionOption[] {
	if (!isSelectionQuestionType(question.type) || question.options.length >= 2) {
		return question.options;
	}

	return [
		...question.options,
		...Array.from(
			{length: 2 - question.options.length},
			(_, index) => createDefaultOption(question.type, question.options.length + index)
		),
	];
}

export function parseSingleSelectionQuestionForSave(
	question: FeedbackStructureSingleSelectionQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, createSelectionConfiguration(question), allQuestions);
}

export function parseMultiSelectionQuestionForSave(
	question: FeedbackStructureMultiSelectionQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, createSelectionConfiguration(question), allQuestions);
}

export function parseDropdownQuestionForSave(
	question: FeedbackStructureDropdownQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {
		points: question.points,
		commentable: question.configuration.commentable,
		comment_prompt: question.configuration.comment_prompt,
		options: question.options.map((option) => createDropdownOptionConfiguration(option)),
	}, allQuestions);
}

export function parseOrderingQuestionForSave(
	question: FeedbackStructureOrderingQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {
		points: question.points,
		options: question.options.map((option) => createOrderingOptionConfiguration(option)),
	}, allQuestions);
}

export function parseSliderQuestionForSave(
	question: FeedbackStructureSliderQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {...question.configuration, points: question.points}, allQuestions);
}

export function parseRatingQuestionForSave(
	question: FeedbackStructureRatingQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {...question.configuration, points: question.points}, allQuestions);
}

export function parseTextInputQuestionForSave(
	question: FeedbackStructureTextInputQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {...question.configuration, points: question.points}, allQuestions);
}

export function parseDateTimeQuestionForSave(
	question: FeedbackStructureDateTimeQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {...question.configuration, points: question.points}, allQuestions);
}

export function parseTimeQuestionForSave(
	question: FeedbackStructureTimeQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {...question.configuration, points: question.points}, allQuestions);
}

export function parseDateQuestionForSave(
	question: FeedbackStructureDateQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, {...question.configuration, points: question.points}, allQuestions);
}

export function parseFilesQuestionForSave(
	question: FeedbackStructureFilesQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return createSaveQuestion(question, createFilesConfiguration(
		toBooleanValue(question.configuration['commentable']),
		toNullableStringValue(question.configuration['comment_prompt'])
	), allQuestions);
}

function createFormQuestion<TType extends FeedbackQuestionType, TConfiguration>(
	question: FeedbackQuestionResource,
	type: TType,
	parsedConfiguration: {
		configuration: TConfiguration;
		points: number;
		options: FeedbackStructureQuestionOption[];
	}
): FeedbackStructureQuestionFormBase<TType, TConfiguration> {
	return {
		client_id: createLocalId('question'),
		id: question.id,
		type,
		position: question.position,
		title: question.title,
		description: question.description,
		required: question.required,
		points: parsedConfiguration.points,
		time_limit_seconds: question.time_limit_seconds,
		auto_advance_on_timeout: question.auto_advance_on_timeout,
		configuration: parsedConfiguration.configuration,
		file_storage_uuids: question.files.map((file) => file.uuid),
		files: question.files,
		options: parsedConfiguration.options,
		logic_rules: question.logic_rules.map((logicRule) => ({
			action: logicRule.action,
			operator: logicRule.operator,
			source_option_position: logicRule.source_option_position,
			value: parseLogicRuleValue(logicRule.value),
			start_question_position: logicRule.start_question_position,
			end_question_position: logicRule.end_question_position,
			client_id: createLocalId('logic'),
			source_option_client_id: null,
			start_question_client_id: null,
			end_question_client_id: null,
			target_question_client_ids: [],
		})),
	};
}

function createSaveQuestion(
	question: FeedbackStructureQuestionFormQuestion,
	configuration: FeedbackFormStructureUpdateRequest['questions'][number]['configuration'],
	allQuestions: FeedbackStructureQuestionFormQuestion[] = [question]
): FeedbackFormStructureUpdateRequest['questions'][number] {
	return {
		id: question.id,
		type: question.type,
		position: question.position,
		title: question.title,
		description: question.description,
		required: question.required,
		time_limit_seconds: question.time_limit_seconds,
		auto_advance_on_timeout: question.auto_advance_on_timeout,
		configuration,
		file_storage_uuids: question.file_storage_uuids,
		logic_rules: serializeLogicRules(question, allQuestions),
	};
}

function parseSingleSelectionConfiguration(
	configuration: FeedbackQuestionSingleSelectionConfigurationResource
): {configuration: FeedbackQuestionSingleSelectionConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const options = configuration.options.map((option) => parseSelectionOption(option));
	const points = toNumber(configuration.points);

	return {
		configuration: {
			points,
			options: options.map((option) => createSelectionOptionConfiguration(option)),
		},
		points,
		options,
	};
}

function parseMultiSelectionConfiguration(
	configuration: FeedbackQuestionMultiSelectionConfigurationResource
): {configuration: FeedbackQuestionMultiSelectionConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const options = configuration.options.map((option) => parseSelectionOption(option));
	const points = toNumber(configuration.points);

	return {
		configuration: {
			points,
			options: options.map((option) => createSelectionOptionConfiguration(option)),
		},
		points,
		options,
	};
}

function parseDropdownConfiguration(
	configuration: FeedbackQuestionDropdownConfigurationResource
): {configuration: FeedbackQuestionDropdownConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const options = configuration.options.map((option) => parseDropdownOption(option));
	const points = toNumber(configuration.points);

	return {
		configuration: {
			points,
			commentable: toBoolean(configuration.commentable),
			comment_prompt: toNullableString(configuration.comment_prompt),
			options: options.map((option) => createDropdownOptionConfiguration(option)),
		},
		points,
		options,
	};
}

function parseOrderingConfiguration(
	configuration: FeedbackQuestionOrderingConfigurationResource
): {configuration: FeedbackQuestionOrderingConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const options = configuration.options.map((option) => parseOrderingOption(option));
	const points = toNumber(configuration.points);

	return {
		configuration: {
			points,
			options: options.map((option) => createOrderingOptionConfiguration(option)),
		},
		points,
		options,
	};
}

function parseSliderConfiguration(
	configuration: FeedbackQuestionSliderConfigurationResource
): {configuration: FeedbackQuestionSliderConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const points = toNumber(configuration.points);

	return {
		configuration: {
			correct_answer: configuration.correct_answer ?? null,
			points,
			commentable: toBoolean(configuration.commentable),
			comment_prompt: toNullableString(configuration.comment_prompt),
			min_value: toNumber(configuration.min_value),
			max_value: toNumber(configuration.max_value),
			step_size: toNumber(configuration.step_size),
			use_value_as_points: configuration.use_value_as_points,
			large_step_marker_interval: toNullableNumber(configuration.large_step_marker_interval),
			small_step_marker_interval: toNullableNumber(configuration.small_step_marker_interval),
			start_value: toNumber(configuration.start_value),
			show_small_step_markers: configuration.show_small_step_markers,
			show_tooltip_on_handle: configuration.show_tooltip_on_handle,
			unit: configuration.unit,
			unit_position: parseUnitPosition(configuration.unit_position),
		},
		points,
		options: [],
	};
}

function parseRatingConfiguration(
	configuration: FeedbackQuestionRatingConfigurationResource
): {configuration: FeedbackQuestionRatingConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const points = toNumber(configuration.points);

	return {
		configuration: {
			correct_answer: configuration.correct_answer ?? null,
			points,
			commentable: toBoolean(configuration.commentable),
			comment_prompt: toNullableString(configuration.comment_prompt),
			allow_half_stars: configuration.allow_half_stars,
			use_rating_as_points: configuration.use_rating_as_points,
		},
		points,
		options: [],
	};
}

function parseTextInputConfiguration(
	configuration: FeedbackQuestionTextInputConfigurationResource
): {configuration: FeedbackQuestionTextInputConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const points = toNumber(configuration.points);

	return {
		configuration: {
			correct_answer: configuration.correct_answer ?? null,
			points,
			commentable: toBoolean(configuration.commentable),
			comment_prompt: toNullableString(configuration.comment_prompt),
		},
		points,
		options: [],
	};
}

function parseDateTimeConfiguration(
	configuration: FeedbackQuestionDateTimeConfigurationResource
): {configuration: FeedbackQuestionDateTimeConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const points = toNumber(configuration.points);

	return {
		configuration: {
			correct_answer: configuration.correct_answer ?? null,
			points,
			commentable: toBoolean(configuration.commentable),
			comment_prompt: toNullableString(configuration.comment_prompt),
		},
		points,
		options: [],
	};
}

function parseTimeConfiguration(
	configuration: FeedbackQuestionTimeConfigurationResource
): {configuration: FeedbackQuestionTimeConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const points = toNumber(configuration.points);

	return {
		configuration: {
			correct_answer: configuration.correct_answer ?? null,
			points,
			commentable: toBoolean(configuration.commentable),
			comment_prompt: toNullableString(configuration.comment_prompt),
		},
		points,
		options: [],
	};
}

function parseDateConfiguration(
	configuration: FeedbackQuestionDateConfigurationResource
): {configuration: FeedbackQuestionDateConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	const points = toNumber(configuration.points);

	return {
		configuration: {
			correct_answer: configuration.correct_answer ?? null,
			points,
			commentable: toBoolean(configuration.commentable),
			comment_prompt: toNullableString(configuration.comment_prompt),
		},
		points,
		options: [],
	};
}

function parseFilesConfiguration(
	configuration: FeedbackQuestionFilesConfigurationResource
): {configuration: FeedbackQuestionFilesConfigurationInput; points: number; options: FeedbackStructureQuestionOption[]} {
	return {
		configuration: createFilesConfiguration(
			toBoolean(configuration.commentable),
			toNullableString(configuration.comment_prompt)
		),
		points: 0,
		options: [],
	};
}

function parseSelectionOption(option: FeedbackQuestionSelectionOptionResource): FeedbackStructureQuestionOption {
	const file = option.file;

	return {
		client_id: createLocalId('option'),
		id: toOptionalNumber(option.id),
		position: toNumber(option.position),
		label: file ? null : toNullableString(option.label),
		points: toNumber(option.points),
		correct_answer: toBoolean(option.correct_answer),
		commentable: toBoolean(option.commentable),
		comment_prompt: toNullableString(option.comment_prompt),
		correct_position: null,
		file_storage_uuid: file?.uuid ?? null,
		file,
	};
}

function parseDropdownOption(option: FeedbackQuestionDropdownOptionResource): FeedbackStructureQuestionOption {
	return {
		client_id: createLocalId('option'),
		id: toOptionalNumber(option.id),
		position: toNumber(option.position),
		label: toNullableString(option.label),
		points: toNumber(option.points),
		correct_answer: toBoolean(option.correct_answer),
		commentable: false,
		comment_prompt: null,
		correct_position: null,
		file_storage_uuid: null,
		file: null,
	};
}

function parseOrderingOption(option: FeedbackQuestionOrderingOptionResource): FeedbackStructureQuestionOption {
	return {
		client_id: createLocalId('option'),
		id: toOptionalNumber(option.id),
		position: toNumber(option.position),
		label: toNullableString(option.label),
		points: toNumber(option.points),
		commentable: toBoolean(option.commentable),
		comment_prompt: toNullableString(option.comment_prompt),
		correct_answer: false,
		correct_position: option.correct_position === undefined ? null : toNumber(option.correct_position),
		file_storage_uuid: null,
		file: null,
	};
}

function createSelectionConfiguration(
	question: FeedbackStructureSingleSelectionQuestion | FeedbackStructureMultiSelectionQuestion
): FeedbackFormStructureUpdateRequest['questions'][number]['configuration'] {
	return {
		points: question.points,
		options: question.options.map((option) => createSelectionOptionConfiguration(option)),
	};
}

function createSelectionOptionConfiguration(
	option: FeedbackStructureQuestionOption
): FeedbackQuestionSelectionOptionInput {
	return {
		...(option.id === undefined ? {} : {id: option.id}),
		position: option.position,
		label: option.file || option.file_storage_uuid ? null : option.label,
		points: option.points ?? 0,
		correct_answer: option.correct_answer ?? false,
		commentable: option.commentable ?? false,
		comment_prompt: option.comment_prompt ?? null,
		file_storage_uuid: option.file_storage_uuid ?? null,
	};
}

function createDropdownOptionConfiguration(
	option: FeedbackStructureQuestionOption
): FeedbackQuestionDropdownOptionInput {
	return {
		...(option.id === undefined ? {} : {id: option.id}),
		position: option.position,
		label: option.label ?? '',
		points: option.points ?? 0,
		correct_answer: option.correct_answer ?? false,
	};
}

function createOrderingOptionConfiguration(
	option: FeedbackStructureQuestionOption
): FeedbackQuestionOrderingOptionInput {
	return {
		...(option.id === undefined ? {} : {id: option.id}),
		position: option.position,
		label: option.label ?? '',
		points: option.points ?? 0,
		correct_position: option.correct_position ?? option.position,
		commentable: option.commentable ?? false,
		comment_prompt: option.comment_prompt ?? null,
	};
}

function createDefaultCommentConfiguration(): {commentable: boolean; comment_prompt: string | null} {
	return {
		commentable: false,
		comment_prompt: null,
	};
}

function createFilesConfiguration(commentable: boolean = false, commentPrompt: string | null = null): FeedbackQuestionFilesConfigurationInput {
	return {
		commentable,
		comment_prompt: commentPrompt,
	};
}

function toNumber(value: number | string | null | undefined): number {
	const parsedValue = Number(value);
	return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function toOptionalNumber(value: string | number | null | undefined): number | undefined {
	if (value === null || value === undefined || value === '') {
		return undefined;
	}

	return toNumber(value);
}

function toNullableNumber(value: string | number | null | undefined): number | null {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	return toNumber(value);
}

function toNullableString(value: string | null | undefined): string | null {
	return value === undefined || value === '' ? null : value;
}

function toBoolean(value: boolean | string | number | null | undefined): boolean {
	return value === true || value === 'true' || value === 1 || value === '1';
}

function toBooleanValue(value: unknown): boolean {
	return value === true || value === 'true' || value === 1 || value === '1';
}

function toNullableStringValue(value: unknown): string | null {
	return typeof value === 'string' && value !== '' ? value : null;
}

function parseUnitPosition(value: string | null): 'left' | 'right' | null {
	return value === 'left' || value === 'right' ? value : null;
}

function parseLogicRuleValue(value: unknown): string | null {
	if (value === null || typeof value === 'string') {
		return value;
	}

	return JSON.stringify(value);
}

export function normalizeFeedbackStructureQuestions(
	questions: FeedbackStructureQuestionFormQuestion[]
): FeedbackStructureQuestionFormQuestion[] {
	const reindexedQuestions = questions.map((question, position) => ({
		...question,
		client_id: question.client_id ?? createLocalId('question'),
		position,
		options: ensureMinimumOptions(question).map((option, optionPosition, options) => ({
			...option,
			client_id: option.client_id ?? createLocalId('option'),
			position: optionPosition,
			correct_position: question.type === FeedbackQuestionType.ORDERING
				? clampCorrectPosition(option.correct_position, options.length)
				: option.correct_position,
		})),
		logic_rules: question.logic_rules.map((logicRule) => ({
			...logicRule,
			value: parseLogicRuleValue(logicRule.value),
			client_id: logicRule.client_id ?? createLocalId('logic'),
			source_option_client_id: logicRule.source_option_client_id ?? null,
			start_question_client_id: logicRule.start_question_client_id ?? null,
			end_question_client_id: logicRule.end_question_client_id ?? null,
			target_question_client_ids: [...(logicRule.target_question_client_ids ?? [])],
		})),
	}));

	const questionById = new Map<string, FeedbackStructureQuestionFormQuestion>();
	const questionPositionById = new Map<string, number>();

	for (const question of reindexedQuestions) {
		if (!question.client_id) {
			continue;
		}

		questionById.set(question.client_id, question);
		questionPositionById.set(question.client_id, question.position);
	}

	return reindexedQuestions.map((question) => ({
		...question,
		logic_rules: question.logic_rules
			.map((logicRule) => normalizeLogicRule(question, logicRule, reindexedQuestions, questionById, questionPositionById))
			.filter((logicRule): logicRule is FeedbackStructureQuestionLogicRule => logicRule !== null),
	}));
}

function normalizeLogicRule(
	question: FeedbackStructureQuestionFormQuestion,
	logicRule: FeedbackStructureQuestionLogicRule,
	allQuestions: FeedbackStructureQuestionFormQuestion[],
	questionById: Map<string, FeedbackStructureQuestionFormQuestion>,
	questionPositionById: Map<string, number>
): FeedbackStructureQuestionLogicRule | null {
	if (!isFeedbackLogicRuleOperatorAllowed(question.type, logicRule.operator)) {
		return null;
	}

	const sourceOptionClientId = resolveSourceOptionClientId(question, logicRule);
	if (logicRuleNeedsSourceOption(question.type, logicRule.operator) && sourceOptionClientId === null) {
		return null;
	}

	if (logicRule.action === FeedbackLogicRuleAction.END_FEEDBACK) {
		return {
			...logicRule,
			source_option_client_id: sourceOptionClientId,
			start_question_client_id: null,
			end_question_client_id: null,
			start_question_position: null,
			end_question_position: null,
			target_question_client_ids: [],
		};
	}

	const targetQuestionClientIds = resolveTargetQuestionClientIds(question, logicRule, allQuestions, questionById);
	const futureTargetQuestionClientIds = targetQuestionClientIds.filter((questionClientId) => {
		const targetQuestionPosition = questionPositionById.get(questionClientId);
		return targetQuestionPosition !== undefined && targetQuestionPosition > question.position;
	});

	if (futureTargetQuestionClientIds.length === 0) {
		return null;
	}

	const fallbackQuestionIds = sortQuestionClientIdsByPosition(futureTargetQuestionClientIds, questionPositionById);
	const startQuestionClientId = resolveBoundaryQuestionClientId(
		logicRule.start_question_client_id,
		fallbackQuestionIds[0],
		questionPositionById,
		question.position
	);
	const endQuestionClientId = resolveBoundaryQuestionClientId(
		logicRule.end_question_client_id,
		fallbackQuestionIds[1],
		questionPositionById,
		question.position
	);

	if (!startQuestionClientId || !endQuestionClientId) {
		return null;
	}

	const startQuestionPosition = questionPositionById.get(startQuestionClientId);
	const endQuestionPosition = questionPositionById.get(endQuestionClientId);
	if (startQuestionPosition === undefined || endQuestionPosition === undefined || startQuestionPosition > endQuestionPosition) {
		return null;
	}

	return {
		...logicRule,
		source_option_client_id: sourceOptionClientId,
		start_question_client_id: startQuestionClientId,
		end_question_client_id: endQuestionClientId,
		start_question_position: startQuestionPosition,
		end_question_position: endQuestionPosition,
		target_question_client_ids: targetQuestionClientIds,
	};
}

function serializeLogicRules(
	question: FeedbackStructureQuestionFormQuestion,
	allQuestions: FeedbackStructureQuestionFormQuestion[]
): FeedbackFormStructureUpdateRequest['questions'][number]['logic_rules'] {
	return question.logic_rules
		.map((logicRule) => serializeLogicRule(question, logicRule, allQuestions))
		.filter((logicRule): logicRule is FeedbackFormStructureUpdateRequest['questions'][number]['logic_rules'][number] => logicRule !== null);
}

function serializeLogicRule(
	question: FeedbackStructureQuestionFormQuestion,
	logicRule: FeedbackStructureQuestionLogicRule,
	allQuestions: FeedbackStructureQuestionFormQuestion[]
): FeedbackFormStructureUpdateRequest['questions'][number]['logic_rules'][number] | null {
	if (!isFeedbackLogicRuleOperatorAllowed(question.type, logicRule.operator)) {
		return null;
	}

	if (question.required && (logicRule.operator === FeedbackLogicRuleOperator.IS_EMPTY || logicRule.operator === FeedbackLogicRuleOperator.IS_NOT_EMPTY)) {
		return null;
	}

	const sourceOptionPosition = logicRule.operator === FeedbackLogicRuleOperator.IS_EMPTY || logicRule.operator === FeedbackLogicRuleOperator.IS_NOT_EMPTY
		? null
		: resolveSourceOptionPosition(question, logicRule);
	if (logicRuleNeedsSourceOption(question.type, logicRule.operator) && sourceOptionPosition === null) {
		return null;
	}

	if (logicRule.action === FeedbackLogicRuleAction.END_FEEDBACK) {
		return {
			action: logicRule.action,
			operator: logicRule.operator,
			source_option_position: serializeSourceOptionPosition(question.type, sourceOptionPosition),
			value: serializeLogicRuleValue(question, logicRule, sourceOptionPosition),
			start_question_position: null,
			end_question_position: null,
		};
	}

	const range = resolveLogicRuleRange(question, logicRule, allQuestions);
	if (range === null) {
		return null;
	}

	return {
		action: logicRule.action,
		operator: logicRule.operator,
		source_option_position: serializeSourceOptionPosition(question.type, sourceOptionPosition),
		value: serializeLogicRuleValue(question, logicRule, sourceOptionPosition),
		start_question_position: range.start,
		end_question_position: range.end,
	};
}

function resolveLogicRuleRange(
	question: FeedbackStructureQuestionFormQuestion,
	logicRule: FeedbackStructureQuestionLogicRule,
	allQuestions: FeedbackStructureQuestionFormQuestion[]
): {start: number; end: number} | null {
	const questionPositionById = new Map<string, number>();
	for (const currentQuestion of allQuestions) {
		if (currentQuestion.client_id) {
			questionPositionById.set(currentQuestion.client_id, currentQuestion.position);
		}
	}

	const startQuestionPosition = resolvePersistedQuestionPosition(logicRule.start_question_client_id, questionPositionById);
	const endQuestionPosition = resolvePersistedQuestionPosition(logicRule.end_question_client_id, questionPositionById);
	if (
		startQuestionPosition !== null
		&& endQuestionPosition !== null
		&& startQuestionPosition > question.position
		&& endQuestionPosition >= startQuestionPosition
	) {
		return {start: startQuestionPosition, end: endQuestionPosition};
	}

	const targetPositions = [...new Set((logicRule.target_question_client_ids ?? [])
		.map((questionClientId) => resolvePersistedQuestionPosition(questionClientId, questionPositionById))
		.filter((targetPosition): targetPosition is number => targetPosition !== null && targetPosition > question.position))]
		.sort((left, right) => left - right);
	if (targetPositions.length > 0) {
		return {
			start: targetPositions[0] ?? null,
			end: targetPositions[targetPositions.length - 1] ?? null,
		};
	}

	if (
		logicRule.start_question_position !== null
		&& logicRule.end_question_position !== null
		&& logicRule.start_question_position > question.position
		&& logicRule.end_question_position >= logicRule.start_question_position
	) {
		return {
			start: logicRule.start_question_position,
			end: logicRule.end_question_position,
		};
	}

	return null;
}

function resolveTargetQuestionClientIds(
	question: FeedbackStructureQuestionFormQuestion,
	logicRule: FeedbackStructureQuestionLogicRule,
	allQuestions: FeedbackStructureQuestionFormQuestion[],
	questionById: Map<string, FeedbackStructureQuestionFormQuestion>
): string[] {
	const persistedQuestionClientIds = (logicRule.target_question_client_ids ?? [])
		.filter((questionClientId) => questionById.has(questionClientId) && questionClientId !== question.client_id);
	if (persistedQuestionClientIds.length > 0) {
		return persistedQuestionClientIds;
	}

	if (logicRule.start_question_client_id && logicRule.end_question_client_id) {
		const startQuestionPosition = questionById.get(logicRule.start_question_client_id)?.position;
		const endQuestionPosition = questionById.get(logicRule.end_question_client_id)?.position;
		if (startQuestionPosition !== undefined && endQuestionPosition !== undefined && startQuestionPosition <= endQuestionPosition) {
			return allQuestions
				.slice(startQuestionPosition, endQuestionPosition + 1)
				.map((currentQuestion) => currentQuestion.client_id)
				.filter((questionClientId): questionClientId is string => !!questionClientId && questionClientId !== question.client_id);
		}
	}

	if (logicRule.start_question_position === null || logicRule.end_question_position === null) {
		return [];
	}

	return allQuestions
		.slice(logicRule.start_question_position, logicRule.end_question_position + 1)
		.map((currentQuestion) => currentQuestion.client_id)
		.filter((questionClientId): questionClientId is string => !!questionClientId && questionClientId !== question.client_id);
}

function resolveSourceOptionClientId(
	question: FeedbackStructureQuestionFormQuestion,
	logicRule: FeedbackStructureQuestionLogicRule
): string | null {
	if (
		logicRule.source_option_client_id
		&& question.options.some((option) => option.client_id === logicRule.source_option_client_id)
	) {
		return logicRule.source_option_client_id;
	}

	if (question.type === FeedbackQuestionType.DROPDOWN) {
		const dropdownOptionPosition = toOptionalNumber(logicRule.value);
		return question.options.find((option) => option.position === dropdownOptionPosition)?.client_id ?? null;
	}

	if (logicRule.source_option_position === null || logicRule.source_option_position === undefined) {
		return null;
	}

	return question.options.find((option) => option.position === logicRule.source_option_position)?.client_id ?? null;
}

function resolveSourceOptionPosition(
	question: FeedbackStructureQuestionFormQuestion,
	logicRule: FeedbackStructureQuestionLogicRule
): number | null {
	if (!logicRule.source_option_client_id) {
		return logicRule.source_option_position ?? null;
	}

	return question.options.find((option) => option.client_id === logicRule.source_option_client_id)?.position ?? null;
}

function serializeSourceOptionPosition(type: FeedbackQuestionType, sourceOptionPosition: number | null): number | null {
	return type === FeedbackQuestionType.DROPDOWN ? null : sourceOptionPosition;
}

function serializeLogicRuleValue(
	question: FeedbackStructureQuestionFormQuestion,
	logicRule: FeedbackStructureQuestionLogicRule,
	sourceOptionPosition: number | null
): string | null {
	if (logicRule.operator === FeedbackLogicRuleOperator.IS_EMPTY || logicRule.operator === FeedbackLogicRuleOperator.IS_NOT_EMPTY) {
		return null;
	}

	switch (question.type) {
		case FeedbackQuestionType.SINGLE_SELECTION:
		case FeedbackQuestionType.MULTI_SELECTION:
			return null;
		case FeedbackQuestionType.ORDERING:
		case FeedbackQuestionType.FILES:
			return null;
		case FeedbackQuestionType.DROPDOWN:
			return sourceOptionPosition === null ? null : String(sourceOptionPosition);
		default:
			return toSerializedLogicRuleString(logicRule.value);
	}
}

function toSerializedLogicRuleString(value: unknown): string | null {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	return typeof value === 'string' ? value : String(value);
}

function sortQuestionClientIdsByPosition(
	questionClientIds: string[],
	questionPositionById: Map<string, number>
): [string | null, string | null] {
	const sortedQuestionIds = [...questionClientIds].sort((left, right) => {
		const leftPosition = questionPositionById.get(left) ?? Number.MAX_SAFE_INTEGER;
		const rightPosition = questionPositionById.get(right) ?? Number.MAX_SAFE_INTEGER;
		return leftPosition - rightPosition;
	});

	return [sortedQuestionIds[0] ?? null, sortedQuestionIds[sortedQuestionIds.length - 1] ?? null];
}

function resolveBoundaryQuestionClientId(
	questionClientId: string | null | undefined,
	fallbackQuestionClientId: string | null,
	questionPositionById: Map<string, number>,
	sourceQuestionPosition: number
): string | null {
	if (!questionClientId) {
		return fallbackQuestionClientId;
	}

	const targetQuestionPosition = questionPositionById.get(questionClientId);
	if (targetQuestionPosition === undefined || targetQuestionPosition <= sourceQuestionPosition) {
		return fallbackQuestionClientId;
	}

	return questionClientId;
}

function resolvePersistedQuestionPosition(
	questionClientId: string | null | undefined,
	questionPositionById: Map<string, number>
): number | null {
	if (!questionClientId) {
		return null;
	}

	return questionPositionById.get(questionClientId) ?? null;
}

function logicRuleNeedsSourceOption(type: FeedbackQuestionType, operator: FeedbackLogicRuleOperator): boolean {
	return isFeedbackLogicRuleOperatorAllowed(type, operator)
		&& (
			(type === FeedbackQuestionType.SINGLE_SELECTION || type === FeedbackQuestionType.MULTI_SELECTION)
			&& (operator === FeedbackLogicRuleOperator.SELECTED || operator === FeedbackLogicRuleOperator.NOT_SELECTED)
		);
}

function clampCorrectPosition(correctPosition: number | null | undefined, optionCount: number): number | null {
	if (typeof correctPosition !== 'number' || !Number.isFinite(correctPosition) || optionCount < 1) {
		return null;
	}

	return Math.min(Math.max(Math.round(correctPosition), 0), optionCount - 1);
}

function createLocalId(prefix: string): string {
	nextLocalId += 1;
	return `${prefix}-${nextLocalId}`;
}
